module.exports = __webpack_public_path__ + "static/media/history_12.30df2c2e.jpg";